import { render, staticRenderFns } from "./CookiesPolicies.vue?vue&type=template&id=9657e670&scoped=true"
import script from "./CookiesPolicies.vue?vue&type=script&lang=js"
export * from "./CookiesPolicies.vue?vue&type=script&lang=js"
import style0 from "./CookiesPolicies.vue?vue&type=style&index=0&id=9657e670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9657e670",
  null
  
)

export default component.exports